(function() {
  var $f0cacb422aeed2fb$export$2e2bcd8739ae039 = (() => {
    if (!customElements.get("related-products")) customElements.define("related-products", class RelatedProducts extends HTMLElement {
      #loading=false;
      #abortController=null;
      #observers=new Set;
      #handleUpdate=null;
      #hideTimeout=null;
      get #productId() {
        return this.dataset.url?.match(/product_id=([0-9]+)/)?.[1];
      }
      async #fetch() {
        if (this.#loading || !this.dataset.url) return;
        this.classList.add("opacity-0");
        clearTimeout(this.#hideTimeout);
        this.#hideTimeout = setTimeout(() => {
          this.classList.add("hidden");
        }, 300);
        this.#loading = true;
        this.toggleAttribute("data-loading", true);
        this.#abortController?.abort();
        this.#abortController = new AbortController;
        try {
          const response = await fetch(this.dataset.url, {
            signal: this.#abortController.signal
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const doc = (new DOMParser).parseFromString(await response.text(), "text/html");
          const recommendations = doc.querySelector(this.tagName.toLowerCase());
          const hasContent = !!recommendations?.innerHTML.trim();
          if (hasContent && this.innerHTML !== recommendations.innerHTML) {
            this.innerHTML = recommendations.innerHTML;
            clearTimeout(this.#hideTimeout);
            this.classList.remove("hidden");
            setTimeout(() => this.classList.remove("opacity-0"), 100);
          }
          requestAnimationFrame(() => {
            this.closest("shopping-cart")?.toggleAttribute("data-has-recommendations", hasContent);
          });
          const labels = doc.querySelector("[data-labels]");
          if (labels) this.closest('.shopify-section:not([id*="drawer"])')?.querySelectorAll("[data-labels]").forEach(el => el.innerHTML = labels.innerHTML);
          this.dispatchEvent(new CustomEvent("related-products:state", {
            detail: {
              hasContent: hasContent,
              loading: true
            },
            bubbles: true
          }));
        } catch (error) {
          if (error.name !== "AbortError") console.warn("Failed to fetch related products:", error);
        } finally {
          this.#loading = false;
          this.toggleAttribute("data-loading", false);
          const hasContent = this.#hasContent();
          this.dispatchEvent(new CustomEvent("related-products:state", {
            detail: {
              hasContent: hasContent,
              loading: false
            },
            bubbles: true
          }));
        }
      }
      #hasContent() {
        const slider = this.querySelector("[data-slider]");
        if (slider) return slider.children.length > 0;
        return this.innerHTML.trim().length > 0 && !this.classList.contains("hidden");
      }
      #observe(observer) {
        this.#observers.add(observer);
        return observer;
      }
      #setupObservers() {
        if (this.hasAttribute("data-lazy")) {
          const observerTarget = this.#resolveLazyObserverTarget();
          this.#observe(new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
              this.#fetch();
              this.#observers.forEach(obs => obs.disconnect());
            }
          }, {
            rootMargin: `0px 0px ${window.innerHeight}px 0px`
          })).observe(observerTarget);
        }
        if (this.hasAttribute("data-update")) {
          this.#handleUpdate = event => {
            const nextUrl = event.detail?.url;
            if (typeof nextUrl === "string" && nextUrl !== this.dataset.url) this.dataset.url = nextUrl;
            this.#fetch();
          };
          this.addEventListener("related-products:update", this.#handleUpdate);
        }
      }
      #resolveLazyObserverTarget() {
        const rootMode = this.dataset.lazyObserverRoot || "self";
        if (rootMode === "section") return this.closest(".shopify-section") || this;
        if (rootMode === "parent") return this.parentElement || this;
        if (rootMode === "selector" && this.dataset.lazyObserverSelector) return document.querySelector(this.dataset.lazyObserverSelector) || this;
        return this;
      }
      async connectedCallback() {
        if (!this.hasAttribute("data-lazy")) await this.#fetch();
        this.#setupObservers();
      }
      disconnectedCallback() {
        this.#abortController?.abort();
        this.#observers.forEach(obs => obs.disconnect());
        this.#observers.clear();
        if (this.#handleUpdate) {
          this.removeEventListener("related-products:update", this.#handleUpdate);
          this.#handleUpdate = null;
        }
      }
      update() {
        return this.#fetch();
      }
    });
  })();
})();